module.exports = __webpack_public_path__ + "static/media/my-maps.ba2d1cb1.svg";